<template>
    <div class="form-group--border">
        <div class="row">
            <div class="col-12">
                <label class="control-label">Вопрос</label>
                <textarea v-model="question.name" class="form-control" rows="3"></textarea>
                <div class="invalid-msg" v-if="v$.question.name.$error">Поле обязательно для заполнения</div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <label class="control-label">Комментарий</label>
                <textarea v-model="question.comment" class="form-control" rows="3"></textarea>
            </div>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component class="btn btn-primary mx-2" v-on:click="save">Сохранить</button-component>
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Отмена</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import {useVuelidate} from "@vuelidate/core";
  import {required} from "@vuelidate/validators";
  export default {
    name: "EditPollQuestion",
    components: {ButtonComponent},
    emits: ['save', 'close'],
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        question: {}
      }
    },
    created() {
      Object.assign(this.question, this.value);
    },
    methods: {
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }
        this.$emit('save', this.question);
      },
      close() {
        this.$emit('close');
      }
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
      return {
        question: {
          name: {required}
        }
      }
    }
  }
</script>
